import { Instagram, Youtube } from "lucide-react";
import { scrollToSection } from "./Navbar";

const legalLinks = [
    { label: "Privacy Policy", href: "/privacy", testid: "footer-privacy-link" },
    { label: "Terms of Service", href: "/terms", testid: "footer-terms-link" },
];

const XIcon = ({ size = 15 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
);

const socials = [
    { label: "Instagram", href: "https://www.instagram.com/rapidclick.in/", Icon: Instagram, testid: "social-instagram" },
    { label: "YouTube", href: "https://www.youtube.com/@rapidclickapp", Icon: Youtube, testid: "social-youtube" },
    { label: "X", href: "https://x.com/inrapidclick", Icon: XIcon, testid: "social-x" },
];

export default function Footer() {
    return (
        <footer data-testid="footer" className="border-t border-line">
            <div className="mx-auto max-w-7xl px-6 py-12 lg:px-10">
                <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
                    <a
                        href="/"
                        onClick={(e) => scrollToSection(e, "#hero")}
                        data-testid="footer-logo"
                        className="flex items-center gap-2.5"
                    >
                        <img
                            src="/app-logo.png"
                            alt="RapidClick logo"
                            className="h-9 w-9 object-contain"
                        />
                        <span className="font-display text-lg font-bold tracking-tight">
                            RapidClick
                        </span>
                    </a>
                    <p className="text-sm text-mute">Never miss a ride.</p>
                    <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-mute">
                        © 2026 RapidClick
                    </p>
                </div>
                <div className="mt-8 flex flex-wrap items-center gap-x-8 gap-y-3 border-t border-line pt-8">
                    <div className="flex items-center gap-3">
                        {socials.map((s) => (
                            <a
                                key={s.href}
                                href={s.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={s.label}
                                data-testid={s.testid}
                                className="flex h-9 w-9 items-center justify-center rounded-full border border-line bg-white text-mute transition-all duration-300 hover:scale-110 hover:border-brand/40 hover:text-brand"
                            >
                                <s.Icon size={15} />
                            </a>
                        ))}
                    </div>
                    {legalLinks.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={l.testid}
                            className="font-mono text-[11px] uppercase tracking-[0.15em] text-mute transition-colors hover:text-ink"
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href="mailto:hello@rapidclick.in"
                        data-testid="footer-support-link"
                        className="font-mono text-[11px] uppercase tracking-[0.15em] text-mute transition-colors hover:text-ink"
                    >
                        hello@rapidclick.in
                    </a>
                </div>
            </div>
        </footer>
    );
}
